<template>
  <div>
    <div class="textcontent" v-html='ksxz'></div>
    <van-checkbox v-model="checked" @click="xuanzhong" style="margin-top: 20px;margin-left: 30px;" shape="square">确认考试协议</van-checkbox>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ksxz: '',
      ksmxid: '',
      checked: false
    };
  },
  async created() {
    let id = this.$route.params.id;
    this.ksmxid = id;
    let that = this;
    const res = await this.$ajax.get('/getksxz');
    this.ksxz = res;
  },
  methods: {
    xuanzhong() {
      console.log("xz",this.checked)
      if(this.checked)
      this.$router.push({ name: 'kaikao', params: { id: this.ksmxid} });
    }
  }
};
</script>

<style>
  .textcontent{
    width: 95%;
    white-space:normal;
    word-wrap: break-word;
    word-break:break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/kaoshi/ksxz.vue